export default __webpack_public_path__ + "static/media/hearthand.4326efe7.jpeg";